<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div
      class="w-100 d-flex flex-column justify-content-between align-items-center"
      style="padding: 24px; margin-top: 82px"
    >
      <Breadcrumb :items="breadcrumbItems" />

      <div id="divTable" style="margin-top: 32px">
        <section class="w-100 mb-4">
          <div
            class="d-flex flex-wrap align-items-center justify-content-between w-100 position-relative px-3 pb-2 border-bottom tabs-container"
          >
            <button
              v-for="tab in tabs"
              :key="tab.id"
              @click="changeTab(tab.id)"
              :class="[
                'border-0 bg-transparent px-3 py-2 fw-bold text-nowrap position-relative tab-item',
                { active: currentTab === tab.id },
              ]"
            >
              {{ tab.label }}({{ tab.count }})
            </button>

            <button
              class="btn btn-primary rounded ms-auto btn-criar-novo"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#modalPostType"
            >
              Nova Postagem
            </button>
          </div>
        </section>

        <div class="table-responsive w-100" v-if="currentTab === 'publicadas'">
          <div
            class="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100 my-4 table-header"
          >
            <h2 class="m-0 fw-bold table-title">Postagens Publicadas</h2>
            <div
              class="d-flex align-items-center justify-content-center rounded w-100 search-wrapper"
            >
              <InputSearch @onUpdate="(value) => publishedByName(value)" />
            </div>
          </div>
          <table class="table align-middle">
            <thead class="thead">
              <tr style="height: 50px">
                <th style="width: 25rem">Postagens</th>
                <th class="th-centered">Tipo</th>
                <th class="th-centered">
                  <div class="interactions-header">
                    <span>Interações</span>
                    <div class="info-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        class="info-icon"
                      >
                        <path
                          d="M7.33331 11.3333H8.66665V7.33331H7.33331V11.3333ZM7.99998 5.99998C8.18887 5.99998 8.34731 5.93598 8.47531 5.80798C8.60331 5.67998 8.66709 5.52176 8.66665 5.33331C8.6662 5.14487 8.6022 4.98665 8.47465 4.85865C8.34709 4.73065 8.18887 4.66665 7.99998 4.66665C7.81109 4.66665 7.65287 4.73065 7.52531 4.85865C7.39776 4.98665 7.33376 5.14487 7.33331 5.33331C7.33287 5.52176 7.39687 5.6802 7.52531 5.80865C7.65376 5.93709 7.81198 6.00087 7.99998 5.99998ZM7.99998 14.6666C7.07776 14.6666 6.21109 14.4915 5.39998 14.1413C4.58887 13.7911 3.88331 13.3162 3.28331 12.7166C2.68331 12.1171 2.20843 11.4115 1.85865 10.6C1.50887 9.78842 1.33376 8.92176 1.33331 7.99998C1.33287 7.0782 1.50798 6.21153 1.85865 5.39998C2.20931 4.58842 2.6842 3.88287 3.28331 3.28331C3.88243 2.68376 4.58798 2.20887 5.39998 1.85865C6.21198 1.50842 7.07865 1.33331 7.99998 1.33331C8.92131 1.33331 9.78798 1.50842 10.6 1.85865C11.412 2.20887 12.1175 2.68376 12.7166 3.28331C13.3158 3.88287 13.7909 4.58842 14.142 5.39998C14.4931 6.21153 14.668 7.0782 14.6666 7.99998C14.6653 8.92176 14.4902 9.78842 14.1413 10.6C13.7924 11.4115 13.3175 12.1171 12.7166 12.7166C12.1158 13.3162 11.4102 13.7913 10.6 14.142C9.78976 14.4926 8.92309 14.6675 7.99998 14.6666Z"
                          fill="#2485EA"
                        />
                      </svg>
                      <div class="info-tooltip">
                        <div class="tooltip-content">
                          <span class="tooltip-title"
                            >Dados de:
                            <span class="tooltip-text-inline"
                              >alcance,</span
                            ></span
                          >
                          <span class="tooltip-text"
                            >curtidas, comentários,</span
                          >
                          <span class="tooltip-text"
                            >compartilhamentos, salvos</span
                          >
                          <span class="tooltip-text"
                            >e visualizações de vídeos</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </th>
                <th class="th-centered">Usuário do Facebook</th>
                <th class="th-centered">Usuário</th>
                <th class="th-centered">Nome da Página</th>
                <th class="th-centered">Criado em</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in published" :key="item.id">
                <td style="width: 25rem">
                  <div
                    class="d-flex align-items-center"
                    style="min-height: 80px"
                  >
                    <img
                      v-if="
                        item.mediaType == 'CAROUSEL_ALBUM' ||
                        item.mediaType == 'IMAGE'
                      "
                      :src="
                        item.mediaUrl != null
                          ? item.mediaUrl
                          : item.instagramMediaContainers &&
                            item.instagramMediaContainers[0]
                          ? item.instagramMediaContainers[0].mediaUrl
                          : ''
                      "
                      @error="handleImageError"
                      alt="image"
                      style="
                        border-radius: 8px;
                        max-width: 20%;
                        margin-right: 10px;
                        flex-shrink: 0;
                      "
                      class="img-postagem"
                    />

                    <video
                      v-else
                      :src="
                        item.mediaUrl != null
                          ? item.mediaUrl
                          : item.instagramMediaContainers &&
                            item.instagramMediaContainers[0]
                          ? item.instagramMediaContainers[0].mediaUrl
                          : ''
                      "
                      alt="image video"
                      class="img-postagem"
                      style="
                        border-radius: 8px;
                        max-width: 20%;
                        margin-right: 10px;
                        flex-shrink: 0;
                      "
                    />
                    <div
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        overflow: hidden;
                        padding-left: 10px;
                      "
                    >
                      <b
                        style="
                          max-width: 35ch;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          display: block;
                        "
                      >
                        {{ item.caption }}
                      </b>
                    </div>
                  </div>
                </td>
                <td class="td-centered">
                  {{ getMediaType(item.mediaType) }}
                </td>
                <td class="td-interactions">
                  <div class="interactions-container">
                    <div class="interaction-item">
                      <img
                        :src="require('@/assets/images/svg/alcance.svg')"
                        alt="Alcance"
                        class="interaction-icon"
                      />
                      <span class="interaction-value">{{
                        item.reachCount || 0
                      }}</span>
                    </div>

                    <div class="interaction-item">
                      <img
                        :src="require('@/assets/images/svg/curtida.svg')"
                        alt="Curtidas"
                        class="interaction-icon"
                      />
                      <span class="interaction-value">{{
                        item.likeCount || 0
                      }}</span>
                    </div>

                    <div class="interaction-item">
                      <img
                        :src="require('@/assets/images/svg/comentario.svg')"
                        alt="Comentários"
                        class="interaction-icon"
                      />
                      <span class="interaction-value">{{
                        item.commentsCount || 0
                      }}</span>
                    </div>

                    <div class="interaction-item">
                      <img
                        :src="
                          require('@/assets/images/svg/compartilhamento.svg')
                        "
                        alt="Compartilhamento"
                        class="interaction-icon"
                      />
                      <span class="interaction-value">{{
                        item.sharesCount || 0
                      }}</span>
                    </div>

                    <div class="interaction-item">
                      <img
                        :src="require('@/assets/images/svg/salvo.svg')"
                        alt="Salvos"
                        class="interaction-icon"
                      />
                      <span class="interaction-value">{{
                        item.savedCount || 0
                      }}</span>
                    </div>

                    <div class="interaction-item">
                      <img
                        :src="require('@/assets/images/svg/vizualizacoes.svg')"
                        alt="Visualizações"
                        class="interaction-icon"
                      />
                      <span class="interaction-value">{{
                        item.playsCount || 0
                      }}</span>
                    </div>
                  </div>
                </td>
                <td class="td-centered">
                  {{ item.facebookUserName ? item.facebookUserName : "-" }}
                </td>
                <td class="td-centered">
                  {{ item.username ? item.username : "-" }}
                </td>
                <td class="td-centered-wrap">
                  {{
                    item.instagramPage && item.instagramPage.pageName
                      ? item.instagramPage.pageName
                      : "-"
                  }}
                </td>
                <td class="td-centered">
                  {{ currentDateTime(item.timestamp) }}
                </td>
                <td class="text-center">
                  <img
                    role="button"
                    @click="
                      $router.push({
                        name: 'Details',
                        params: { id: item.instaMediaId },
                      })
                    "
                    :src="
                      require(`@/assets/images/svg/ícone-seta-direita-azul.svg`)
                    "
                    alt=""
                    style="cursor: pointer"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :count="totalPublished"
            :offset="offset"
            :limit="4"
            @firstPage="pagination('clickFirstPage', false)"
            @previousPage="pagination('clickPreviousPage', false)"
            @nextPage="pagination('clickNextPage', false)"
            @lastPage="pagination('clickLastPage', false)"
          />
        </div>

        <div class="table-responsive w-100" v-if="currentTab === 'agendadas'">
          <div
            class="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100 my-4 table-header"
          >
            <h2 class="m-0 fw-bold table-title">Postagens Agendadas</h2>
            <div
              class="d-flex align-items-center justify-content-center rounded w-100 search-wrapper"
            >
              <InputSearch @onUpdate="(value) => scheduledByName(value)" />
            </div>
          </div>
          <table class="table align-middle">
            <thead class="thead">
              <tr style="height: 50px">
                <th style="width: 25rem">Postagens</th>
                <th>Descrição</th>
                <th>Tipo</th>
                <th>Agendado Para</th>
                <th>Criado em</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in scheduled" :key="item.id">
                <td>
                  <div class="d-flex align-items-center flex-wrap">
                    <img
                      :src="item.mediasContainers[0].mediaUrl"
                      @error="handleImageError"
                      alt=""
                      style="
                        border-radius: 8px;
                        max-width: 20%;
                        margin-right: 10px;
                      "
                      class="img-postagem"
                    />
                    <span
                      v-if="item.caption === String"
                      class="d-flex flex-column align-items-start justify-content-between"
                    >
                      <b style="margin-bottom: 8px">{{ item.caption }}</b>
                      <p class="m-0">
                        {{ item.instaPageName ? item.instaPageName : "-" }}
                      </p>
                    </span>
                  </div>
                </td>
                <td>{{ item.caption }}</td>
                <td>{{ item.mediaType }}</td>
                <td>{{ currentScheduleDateTime(item.scheduleDate) }}</td>
                <td>{{ currentDateTimeCreatedAt(item.createdAt) }}</td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :count="totalScheduled"
            :offset="offset"
            :limit="4"
            @firstPage="pagination('clickFirstPage', true)"
            @previousPage="pagination('clickPreviousPage', true)"
            @nextPage="pagination('clickNextPage', true)"
            @lastPage="pagination('clickLastPage', true)"
          />
        </div>

        <div class="table-responsive w-100" v-if="currentTab === 'pendentes'">
          <div
            class="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100 my-4 table-header"
          >
            <h2 class="m-0 fw-bold table-title">Postagens Pendentes</h2>
            <div
              class="d-flex align-items-center justify-content-center rounded w-100 search-wrapper"
            >
              <InputSearch @onUpdate="(value) => pendingByName(value)" />
            </div>
          </div>
          <table class="table align-middle">
            <thead class="thead">
              <tr style="height: 50px">
                <th style="width: 25rem">Postagens</th>
                <th class="th-centered">Tipo</th>
                <th class="th-centered">Usuário</th>
                <th class="th-centered">Usuário do Facebook</th>
                <th class="th-centered">Nome da Página</th>
                <th>Status</th>
                <th class="th-centered">Criado em</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in pending" :key="item.id">
                <td style="width: 25rem">
                  <div
                    class="d-flex align-items-center"
                    style="min-height: 80px"
                  >
                    <template
                      v-if="
                        item.mediaType == 'IMAGE' ||
                        item.mediaType == 'CAROUSEL_ALBUM'
                      "
                    >
                      <img
                        v-if="item.mediaUrl && item.mediaUrl.length > 0"
                        :src="item.mediaUrl"
                        alt="image"
                        style="
                          border-radius: 8px;
                          max-width: 20%;
                          margin-right: 10px;
                          flex-shrink: 0;
                        "
                        class="img-postagem"
                        @error="handleImageError"
                      />
                      <img
                        v-else-if="
                          item.instagramMediaContainers &&
                          item.instagramMediaContainers.length > 0 &&
                          item.instagramMediaContainers[0].mediaUrl
                        "
                        :src="item.instagramMediaContainers[0].mediaUrl"
                        alt="image"
                        style="
                          border-radius: 8px;
                          max-width: 20%;
                          margin-right: 10px;
                          flex-shrink: 0;
                        "
                        class="img-postagem"
                        @error="handleImageError"
                      />
                      <img
                        v-else-if="
                          item.instagramPage &&
                          item.instagramPage.profilePictureUrl
                        "
                        :src="item.instagramPage.profilePictureUrl"
                        alt="profile picture"
                        style="
                          border-radius: 8px;
                          max-width: 20%;
                          margin-right: 10px;
                          flex-shrink: 0;
                        "
                        class="img-postagem"
                        @error="handleImageError"
                      />
                      <div
                        v-else
                        style="
                          border-radius: 8px;
                          max-width: 20%;
                          margin-right: 10px;
                          width: 80px;
                          height: 80px;
                          background-color: var(--grey-light);
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          color: #999;
                          font-size: 12px;
                          flex-shrink: 0;
                        "
                      >
                        Sem mídia
                      </div>
                    </template>

                    <template v-else-if="item.mediaType == 'VIDEO'">
                      <video
                        v-if="item.mediaUrl"
                        :src="item.mediaUrl"
                        alt="video"
                        class="img-postagem"
                        style="
                          border-radius: 8px;
                          max-width: 20%;
                          margin-right: 10px;
                          flex-shrink: 0;
                        "
                      />
                      <video
                        v-else-if="
                          item.instagramMediaContainers &&
                          item.instagramMediaContainers[0] &&
                          item.instagramMediaContainers[0].mediaUrl
                        "
                        :src="item.instagramMediaContainers[0].mediaUrl"
                        alt="video"
                        class="img-postagem"
                        style="
                          border-radius: 8px;
                          max-width: 20%;
                          margin-right: 10px;
                          flex-shrink: 0;
                        "
                      />
                      <div
                        v-else
                        style="
                          border-radius: 8px;
                          max-width: 20%;
                          margin-right: 10px;
                          width: 80px;
                          height: 80px;
                          background-color: var(--grey-light);
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          color: #999;
                          font-size: 12px;
                          flex-shrink: 0;
                        "
                      >
                        Sem mídia
                      </div>
                    </template>

                    <div
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        overflow: hidden;
                        padding-left: 10px;
                      "
                    >
                      <b
                        style="
                          max-width: 35ch;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          display: block;
                        "
                      >
                        {{ item.caption || "Sem legenda" }}
                      </b>
                    </div>
                  </div>
                </td>
                <td class="td-centered">
                  {{ getMediaType(item.mediaType) }}
                </td>
                <td class="td-centered">
                  {{ item.username ? item.username : "-" }}
                </td>
                <td class="td-centered">
                  {{ item.facebookUserName ? item.facebookUserName : "-" }}
                </td>
                <td class="td-centered-wrap">
                  {{
                    item.instagramPage && item.instagramPage.pageName
                      ? item.instagramPage.pageName
                      : "-"
                  }}
                </td>
                <td>{{ translateStatus(item.publishStatus) }}</td>
                <td class="td-centered">
                  {{ currentDateTime(item.timestamp) }}
                </td>
                <td class="text-center">
                  <img
                    role="button"
                    @click="pushDetailsPending(item)"
                    :src="
                      require(`@/assets/images/svg/ícone-seta-direita-azul.svg`)
                    "
                    alt=""
                    style="cursor: pointer"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :count="totalPending"
            :offset="offsetPending"
            :limit="4"
            @firstPage="paginationPending('clickFirstPage')"
            @previousPage="paginationPending('clickPreviousPage')"
            @nextPage="paginationPending('clickNextPage')"
            @lastPage="paginationPending('clickLastPage')"
          />
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalPostType"
      tabindex="-1"
      aria-labelledby="modalPostTypeLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content align-items-center">
          <div class="modal-header border-0" style="width: 80%"></div>
          <div class="modal-body" style="width: 80%">
            <h2
              class="modal-title"
              id="modalPostTypeLabel"
              style="
                font-style: normal;
                font-weight: 700;
                font-size: 34px;
                color: var(--black-medium);
              "
            >
              Escolha Tipo
            </h2>
            <p
              style="
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: var(--grey-medium);
              "
            >
              Escolha o tipo de publicação que deseja utilizar para a sua
              postagem
            </p>
          </div>
          <div
            class="modal-footer border-0 justify-content-center"
            style="width: 80%; margin-bottom: 16px"
          >
            <button
              v-if="isADM"
              @click="pushNewPost"
              style="
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: var(--white);
                background-color: var(--blue-medium);
                text-align: center;
              "
              class="text-decoration-none btn-default"
            >
              Comum
            </button>

            <!-- <button
              v-if="isADM"
              @click="pushNewPostStory"
              style="
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: var(--white);
                background-color: var(--blue-medium);
                text-align: center;
              "
              class="text-decoration-none btn-default"
            >
              Story
            </button> -->
            <button
              @click="pushNewPostMarketing"
              style="
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: var(--white);
                background-color: var(--blue-medium);
                text-align: center;
              "
              class="text-decoration-none btn-default"
            >
              Marketing na Loja
            </button>
            <button
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeModalPostType"
              class="btn"
              style="
                background-color: transparent;
                outline: none;
                color: var(--blue-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
              "
            >
              Voltar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputSearch from "@/components/InputSearch.vue";
import Pagination from "@/components/Pagination.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import moment from "moment/moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loading from "vue-loading-overlay";
import apiGerenciarMidiasService from "../service/apiGerenciarMidiasService";
import * as bootstrap from "bootstrap";

export default {
  components: { InputSearch, Pagination, Loading, Breadcrumb },
  data() {
    return {
      currentTab: "publicadas",
      isPublicadas: true,
      isLoading: false,
      totalScheduled: 0,
      totalPublished: 0,
      totalPending: 0,
      offset: 0,
      offsetAgendada: 0,
      offsetPending: 0,
      namePublishedToSearch: "",
      nameScheduledToSearch: "",
      namePendingToSearch: "",
      limitAgendada: 0,
      scheduled: [],
      published: [],
      pending: [],
      selectedPendingItem: null,
      user: {
        roles: [],
      },
      isADM: false,
    };
  },
  async created() {
    this.isLoading = true;

    // Verifica se deve abrir a aba de pendentes
    if (this.$route.params.tab === "pendentes") {
      this.currentTab = "pendentes";
      this.isPublicadas = false;
    }

    // inicio postagem punlicadas
    let responsePublished = [];
    responsePublished = await apiGerenciarMidiasService.getAllMedias({
      isPosts: true,
      isScheduled: false,
      offset: 0,
      name: this.namePublishedToSearch,
      limit: 4,
    });

    if (responsePublished.status === 200 && this.isPublicadas) {
      this.totalPublished = responsePublished.data.count;
      this.published = responsePublished.data.data;
    }
    //fim postagem publicadas

    //inicio postagem agendada
    const responseScheduled =
      await apiGerenciarMidiasService.getScheduledMedias({
        isPosts: true,
        isScheduled: true,
        offset: 0,
        name: this.nameScheduledToSearch,
        limit: 4,
      });

    if (responseScheduled.status === 200) {
      this.totalScheduled = responseScheduled.data.count;
      this.scheduled = responseScheduled.data.data;
    }

    //fim postagem agendada

    //inicio postagem pendente
    const responsePending = await apiGerenciarMidiasService.getPendingMedias(
      5,
      0,
      "-timestamp"
    );

    if (responsePending.status === 200) {
      this.pending = responsePending.data.data;
      this.totalPending = responsePending.data.count;
    }
    //fim postagem pendente

    this.getUser();
    this.isLoading = false;
  },
  computed: {
    ...mapGetters(["getOffset"]),
    tabs() {
      return [
        { id: "publicadas", label: "Publicadas", count: this.totalPublished },
        { id: "agendadas", label: "Agendadas", count: this.totalScheduled },
        { id: "pendentes", label: "Pendentes", count: this.totalPending },
      ];
    },
    currentTabName() {
      switch (this.currentTab) {
        case "publicadas":
          return "Publicadas";
        case "agendadas":
          return "Agendadas";
        case "pendentes":
          return "Pendentes";
        default:
          return "Publicadas";
      }
    },
    breadcrumbItems() {
      return [
        { label: "Dashboard", route: { name: "Dashboard" } },
        { label: "Postagens", route: { name: "Posts" } },
        { label: this.currentTabName, active: true },
      ];
    },
  },
  watch: {},
  methods: {
    ...mapMutations(["SET_OFFSET"]),
    ...mapActions(["getUserByEmail"]),

    currentDateTime(timestamp) {
      if (!timestamp) return "-";
      return moment.utc(timestamp).format("DD/MM/YYYY HH:mm");
    },
    currentDateTimeCreatedAt(timestamp) {
      if (!timestamp) return "-";
      return moment.utc(timestamp).format("DD/MM/YYYY HH:mm");
    },
    currentScheduleDateTime(timestamp) {
      if (!timestamp) return "-";
      return moment.utc(timestamp).format("DD/MM/YYYY HH:mm");
    },
    handleImageError(event) {
      event.target.src = require("@/assets/images/imagedefault.png");
    },
    pushNewPost() {
      this.$refs.closeModalPostType.click();
      return this.$router.push({ name: "NewPost" });
    },
    pushNewPostStory() {
      this.$refs.closeModalPostType.click();
      return this.$router.push({ name: "NewPost", params: { isStory: true } });
    },
    pushNewPostMarketing() {
      this.$refs.closeModalPostType.click();
      return this.$router.push({ name: "NewPostMarketing" });
    },
    changeTab(tab) {
      this.currentTab = tab;
      this.isPublicadas = tab === "publicadas";
    },
    exibirOcultar(value) {
      this.isPublicadas = value;
      this.currentTab = value ? "publicadas" : "agendadas";
    },
    publishedByName: function publishedByName(name) {
      this.namePublishedToSearch = name;

      if (this.namePublishedToSearch != "") {
        let objThis = this;

        clearTimeout(publishedByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage", false);
        }, 500);
      } else {
        this.pagination("clickFirstPage", false);
      }
    },
    scheduledByName: function scheduledByName(name) {
      this.nameScheduledToSearch = name;

      if (this.nameScheduledToSearch != "") {
        let objThis = this;

        clearTimeout(scheduledByName);

        setTimeout(function () {
          objThis.paginationAgendada("clickFirstPage", true);
        }, 500);
      } else {
        this.paginationAgendada("clickFirstPage", true);
      }
    },
    async pagination(action, isScheduled) {
      const data = {
        action: action,
        isPosts: true,
        isScheduled: !isScheduled ? false : true,
        name: !isScheduled
          ? this.namePublishedToSearch
          : this.nameScheduledToSearch,
        offset: 0,
        limit: 4,
      };

      switch (action) {
        case "clickFirstPage": {
          this.isLoading = true;
          this.offset = 0;
          this.SET_OFFSET(0);
          if (this.isPublicadas) {
            await apiGerenciarMidiasService
              .getAllMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          } else {
            await apiGerenciarMidiasService
              .getScheduledMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          }
        }
        case "clickPreviousPage": {
          this.isLoading = true;
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          if (this.isPublicadas) {
            await apiGerenciarMidiasService
              .getAllMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          } else {
            await apiGerenciarMidiasService
              .getScheduledMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          }
        }
        case "clickNextPage": {
          this.isLoading = true;
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          if (this.isPublicadas) {
            await apiGerenciarMidiasService
              .getAllMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          } else {
            await apiGerenciarMidiasService
              .getScheduledMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          }
        }
        case "clickLastPage": {
          this.isLoading = true;
          let lastPage;
          let total = !isScheduled ? this.totalPublished : this.totalScheduled;

          if (total % data.limit === 0) {
            lastPage = total - data.limit;
          } else {
            lastPage = Math.floor(total / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          if (this.isPublicadas) {
            await apiGerenciarMidiasService
              .getAllMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          } else {
            await apiGerenciarMidiasService
              .getScheduledMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          }
        }
        default: {
          break;
        }
      }
    },
    async getUser() {
      await this.getUserByEmail().then((response) => {
        const data = response.data.data[0];
        this.user.roles = data.roles;
      });

      if (this.user.roles.includes("Administrador")) {
        this.isADM = true;
      } else {
        this.isADM = false;
      }
    },
    pushDetailsAgendada(id, date) {
      this.$router.push({ name: "DetailsAgendada", params: { id: id } });
    },
    pushDetailsPending(item) {
      this.selectedPendingItem = item;
      this.$router.push({
        name: "Details",
        params: {
          id: item.instaMediaId || item.id,
          isPending: true,
          pendingItem: item,
        },
      });
    },
    pendingByName: function pendingByName(name) {
      this.namePendingToSearch = name;

      if (this.namePendingToSearch != "") {
        let objThis = this;

        clearTimeout(pendingByName);

        setTimeout(function () {
          objThis.paginationPending("clickFirstPage");
        }, 500);
      } else {
        this.paginationPending("clickFirstPage");
      }
    },
    async paginationPending(action) {
      const limit = 4;

      switch (action) {
        case "clickFirstPage": {
          this.isLoading = true;
          this.offsetPending = 0;
          this.SET_OFFSET(0);
          await apiGerenciarMidiasService
            .getPendingMedias(limit, this.offsetPending, "-timestamp")
            .then((response) => {
              this.totalPending = response.data.count;
              this.pending = response.data.data;
              this.isLoading = false;
            });
          break;
        }
        case "clickPreviousPage": {
          this.isLoading = true;
          this.offsetPending = this.offsetPending - limit;

          await apiGerenciarMidiasService
            .getPendingMedias(limit, this.offsetPending, "-timestamp")
            .then((response) => {
              this.totalPending = response.data.count;
              this.pending = response.data.data;
              this.isLoading = false;
            });
          break;
        }
        case "clickNextPage": {
          this.isLoading = true;
          this.offsetPending = this.offsetPending + limit;

          await apiGerenciarMidiasService
            .getPendingMedias(limit, this.offsetPending, "-timestamp")
            .then((response) => {
              this.totalPending = response.data.count;
              this.pending = response.data.data;
              this.isLoading = false;
            });
          break;
        }
        case "clickLastPage": {
          this.isLoading = true;
          let lastPage;

          if (this.totalPending % limit === 0) {
            lastPage = this.totalPending - limit;
          } else {
            lastPage = Math.floor(this.totalPending / limit) * limit;
          }

          this.offsetPending = lastPage;

          await apiGerenciarMidiasService
            .getPendingMedias(limit, this.offsetPending, "-timestamp")
            .then((response) => {
              this.totalPending = response.data.count;
              this.pending = response.data.data;
              this.isLoading = false;
            });
          break;
        }
        default: {
          break;
        }
      }
    },
    translateStatus(status) {
      const statusMap = {
        WAITING: "Aguardando",
        PUBLISHED: "Publicado",
        ERROR: "Erro",
      };
      return statusMap[status] || status || "-";
    },
    getMediaType(mediaType) {
      const typeMap = {
        IMAGE: "Imagem",
        VIDEO: "Video",
        CAROUSEL_ALBUM: "Carrosel",
        "STORIES - IMAGE": "Stories (Imagem)",
        "STORIES - VIDEO": "Stories (Video)",
      };
      return typeMap[mediaType] || "-";
    },
  },
};
</script>
<style scoped>
#divTable {
  width: 100%;
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 24px 16px 24px 32px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  background-color: var(--white);
  margin-bottom: 22px;
}

.table {
  margin: 0;
}

.table td,
.table th {
  vertical-align: middle;
}

.table th {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey-medium);
  text-align: start;
}

thead.thead {
  border-color: var(--blue-light);
}

tbody tr:nth-last-child(even) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}

tbody tr:nth-last-child(odd) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}

.short-text {
  max-width: 35ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Colunas centralizadas - Evita quebra de linha */
.td-centered {
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

/* Coluna centralizada - Permite quebra de linha (Nome da Página) */
.td-centered-wrap {
  text-align: center;
  vertical-align: middle;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 200px;
}

.th-centered {
  text-align: center !important;
}

/* Coluna de Interações */
.td-interactions {
  padding: 16px;
}

.interactions-container {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.interaction-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.interaction-icon {
  width: 24px;
  height: 24px;
}

.interaction-value {
  color: var(--Text-Body, #383838);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.42px;
}

/* Header de Interações com ícone de info */
.interactions-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.info-icon-wrapper {
  position: relative;
  display: inline-flex;
  cursor: pointer;
}

.info-icon {
  width: 16px;
  height: 16px;
  display: block;
}

/* Tooltip */
.info-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 2px;
  background: var(--Default-Colors-Black, #000);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 1000;
  width: 211px;
}

.info-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: var(--Default-Colors-Black, #000);
}

.info-icon-wrapper:hover .info-tooltip {
  opacity: 1;
  visibility: visible;
}

.tooltip-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  width: 100%;
  text-align: left;
}

.tooltip-title {
  color: var(--Default-Colors-White, #fff) !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 143%;
  display: block;
  width: 100%;
  word-wrap: break-word;
  text-align: left;
}

.tooltip-text-inline {
  color: var(--Default-Colors-White, #fff) !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  display: inline;
  text-align: left;
}

.tooltip-text {
  color: var(--Default-Colors-White, #fff) !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  display: block;
  width: 100%;
  word-wrap: break-word;
  text-align: left;
}

/* Tabs Container - Apenas ajustes específicos */
.tabs-container {
  gap: 8px;
  border-color: var(--blue-light) !important;
}

/* Tab Item - Cores e comportamento específico */
.tab-item {
  cursor: pointer;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: normal;
  color: var(--blue-medium);
  transition: color 0.2s ease;
}

.tab-item:hover {
  color: var(--black-medium);
}

.tab-item.active {
  color: var(--black-medium);
}

.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #000000;
}

/* Botão Nova Postagem - Apenas dimensões específicas */
.btn-criar-novo {
  height: 40px;
  width: 160px;
  transition: opacity 0.2s ease;
}

.btn-criar-novo:hover {
  opacity: 0.9;
}

/* Table Header - Apenas gap específico */
.table-header {
  gap: 16px;
}

/* Table Title - Cores e tipografia específicas */
.table-title {
  color: var(--grey-medium);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Roboto, sans-serif;
  font-size: 28px;
  font-style: normal;
  line-height: normal;
}

/* Search Wrapper - Background e dimensões específicas */
.search-wrapper {
  background: var(--grey-light);
  max-width: 471px;
  height: 40px;
}

/* Responsividade - Apenas gap específico */
@media (min-width: 768px) {
  .table-header {
    gap: 80px;
  }

  .search-wrapper {
    width: 471px;
  }
}
</style>
